import { AxiosResponse } from "axios";

import {
  IMissingBaseline,
  IPatientBaselineDetail,
  IPatientWithBaselines,
} from "../../@types/admin/AdminBaseline";
import { api } from "../api";

/**
 * Baselines admin page (EN-5168), migrated from the Retool Baselines app. All
 * three of its queries hit the pMp DB directly; they are ported into these
 * endpoints so Retool and the portal read the same rows during the transition.
 */
export const baselinesService = {
  /** Patients that have at least one recorded baseline. */
  async getPatientsWithBaselines(): Promise<
    AxiosResponse<IPatientWithBaselines[]>
  > {
    return api.get<IPatientWithBaselines[]>("/Retool/Baselines");
  },

  /** One patient's baselines, newest first, archived ones included. */
  async getPatientBaselines(
    patientId: number
  ): Promise<AxiosResponse<IPatientBaselineDetail[]>> {
    return api.get<IPatientBaselineDetail[]>(
      `/Retool/Baselines/Patients/${patientId}`
    );
  },

  /**
   * Patients whose ward runs a published workflow with a baseline rule and who
   * have no baseline that rule can use. The heaviest read on the page.
   */
  async getMissingBaselines(): Promise<AxiosResponse<IMissingBaseline[]>> {
    return api.get<IMissingBaseline[]>("/Retool/Baselines/Missing");
  },
};
